<efp-scrollbar efpWatchParentDimensions (dimensionsChange)="dimensionsChange.next($event)">
  <div class="inner-bottom-menu-container">
    <ng-content></ng-content>
  </div>
</efp-scrollbar>
